import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplaySkinsComponent } from './display-skins/display-skins.component';
import { ScoreboardHeaderComponent } from './scoreboard-header/scoreboard-header.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { EventSummaryComponent } from './event-summary/event-summary.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThruBadgeComponent } from './thru-badge/thru-badge.component';
import { StartOrderComponent } from './start-order/start-order.component';
import { ScoreBadgeComponent } from './score-badge/score-badge.component';
import { FlightDescComponent } from './flight-desc/flight-desc.component';
import { TiebreakerIndicatorComponent } from './tiebreaker-indicator/tiebreaker-indicator.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatMenuModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    SharedModule
  ],
  declarations: [
    DisplaySkinsComponent,
    ScoreboardHeaderComponent,
    EventSummaryComponent,
    ThruBadgeComponent,
    StartOrderComponent,
    ScoreBadgeComponent,
    FlightDescComponent,
    TiebreakerIndicatorComponent
  ],
  exports: [
    DisplaySkinsComponent,
    ScoreboardHeaderComponent,
    EventSummaryComponent,
    ThruBadgeComponent,
    StartOrderComponent,
    ScoreBadgeComponent,
    FlightDescComponent,
    TiebreakerIndicatorComponent
  ]
})
export class ResultsSharedModule { }
